var _circle, _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBuyTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.668 12.4712L18.0974 17.3049L17.2731 17.9038H12.1907L16.3025 20.8912L16.6173 21.8602L15.0468 26.6939L19.1586 23.7065H20.1774L24.2892 26.6939L22.7186 21.8602L23.0334 20.8912L27.1452 17.9038H22.0628L21.2385 17.3049L19.668 12.4712ZM16.6435 16.1705L18.8437 9.39883H20.4922L22.6925 16.1705H29.8126L30.322 17.7383L24.5617 21.9234L26.7619 28.695L25.4283 29.664L19.668 25.4789L13.9077 29.664L12.574 28.695L14.7742 21.9234L9.01395 17.7383L9.52336 16.1705H16.6435Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyTickets);
export default __webpack_public_path__ + "static/media/buy-tickets.98a54db55e8802784edb8ac713a7cdd2.svg";
export { ForwardRef as ReactComponent };